module.exports = __webpack_public_path__ + "img/sign_error.d2d8c31c.svg";